'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.845 7.133 3.844 3.646a.98.98 0 0 1 .31.694 1.011 1.011 0 0 1-.266.714l-.225.242c-.349.399-.939.446-1.343.107l-.67-.62v9.077a1.038 1.038 0 0 1-.284.713.97.97 0 0 1-.688.294H5.478a.943.943 0 0 1-.689-.294 1.01 1.01 0 0 1-.285-.713v-9.078l-.669.62a.957.957 0 0 1-1.343-.107l-.225-.241A.985.985 0 0 1 2 11.474a1.008 1.008 0 0 1 .31-.695l8.951-8.493c.106-.1.231-.175.366-.222l.006-.001a1.083 1.083 0 0 1 .178-.047c.018-.003.037-.005.056-.006h.014a.778.778 0 0 1 .26.001 1.08 1.08 0 0 1 .212.049l.018.005c.135.047.26.123.366.222l2.475 2.348.005-.554a1.01 1.01 0 0 1 .286-.705.943.943 0 0 1 .688-.277l.664.008a.961.961 0 0 1 .676.274c.183.178.293.422.307.681l.006 3.07Zm-4.077 3.6a2.5 2.5 0 1 0-3.536 3.536 2.5 2.5 0 0 0 3.536-3.537ZM17 18.75c0-1.381-2.238-2.5-5-2.5s-5 1.119-5 2.5V20h10v-1.25Z",
    fill: "currentColor"
  }));
});
var HousePerson = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.HousePerson = HousePerson;